import React from 'react';
import './Legend.scss';

/**
 * `keep`/`lost` are the funnel's two bar segments; the four after them are the SLA bands. One union
 * rather than a legend per panel, because the swatch is the same square either way — only its fill
 * differs, and every fill resolves to a token in `panel-tokens.scss`.
 */
type LegendItemType = 'keep' | 'lost' | 'within' | 'at-risk' | 'breaching' | 'not-registered';

interface LegendItem {
  label: string;
  type: LegendItemType;
}

interface LegendProps {
  items: LegendItem[];
}

/**
 * A key for the bars, and only that. It carried a trailing `note` for a caption about how the bars were
 * scaled; the funnel's one caption turned out to be false and was removed rather than corrected, and a
 * legend is the wrong place for prose in any case — the panel header carries the configured blurb, and
 * anything specific to a row belongs on that row, behind its own `InfoTooltip`.
 */
export const Legend: React.FC<LegendProps> = ({ items }) => (
  <div className="ovp-legend">
    {items.map((item) => (
      <span key={item.label} className="ovp-legend__item">
        <span className={`ovp-legend__swatch ovp-legend__swatch--${item.type}`} />
        {item.label}
      </span>
    ))}
  </div>
);
